import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../sources/redux/actions';
import { toast } from 'react-toastify';
import { socialIcons } from '../../../styles/icons';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import {withFirebase} from '../../../Firebase';
import {
    FACEBOOK_APP_ID,
    FACEBOOK_SOCIAL_ICOSNS_KEY,
    FACEBOOK_CONNECT_SCOPE,
    FACEBOOK_CONNECTION_ERROR_MSG,
} from '../../sources/redux/constants';
import { getUserEmailFromLocalStorage } from '../../../Firebase/localStorageForUserInfo';
import qs from 'qs';
import PropTypes from 'prop-types';



export class FacebookConnect extends Component {

    static propTypes = {
        actions: PropTypes.object.isRequired,
        setFacebookConnectionStateWhenConnectingToFacebook: PropTypes.func.isRequired,
        sources: PropTypes.object.isRequired
      };
    
    componentDidMount() {
        const parsed               = qs.parse(window.location.hash,  { ignoreQueryPrefix: true });
        const accessToken          = parsed['#access_token'];
        const expiresIn            = parsed['expires_in'];
        if (accessToken && expiresIn) {
            const { updateFacebookConnection } = this.props.actions;
            this.props.setFacebookConnectionStateWhenConnectingToFacebook({
                facebookUserId: null,
                facebookAccessToken: accessToken
            });
            this.setState(() => {
                updateFacebookConnection({
                    short_lived_api_token: accessToken,
                    short_lived_api_token_expires_in: expiresIn,
                    fb_user_id: null,
                    resonance_user_email: getUserEmailFromLocalStorage()
                });
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.sources.update_facebook_connection_error) {
            toast.error(FACEBOOK_CONNECTION_ERROR_MSG);
        }
    }

    render() {
        const redirectUri = window.location.origin + window.location.pathname;
        return (
            <FacebookLogin
              appId={FACEBOOK_APP_ID}
              autoLoad={false}
              isMobile={true}
              scope={FACEBOOK_CONNECT_SCOPE}
              redirectUri={redirectUri}
              responseType="token"
              render={renderProps => (
                <span onClick={renderProps.onClick} className="facebook-connection-btn">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: socialIcons[FACEBOOK_SOCIAL_ICOSNS_KEY]
                            }}
                        />
                       (Connect)
                    </span>
              )}
            />
        )
    }
}

function mapStateToProps(state) {
    return {
        sources: state.sources,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ ...actions }, dispatch),
    };
}

export default withFirebase(connect(mapStateToProps, mapDispatchToProps)(FacebookConnect));


// WEBPACK FOOTER //
// ./src/features/shared-components/FacebookConnect/FacebookConnect.js